// extracted by mini-css-extract-plugin
module.exports = {"hide":"SignUp_hide__3UGU0","center":"SignUp_center__2UTqE","title":"SignUp_title__fBpbb"};